<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

/* Garanti alanına isim yazdırma zorunlu */

/* custom.js — Garanti Bilgisi dolmadan butonları kilitle */
(function () {
  if (window.__checkoutGuardInstalled__) return;
  window.__checkoutGuardInstalled__ = true;

  // Gerekirse bu seçicileri kendi HTML’inize göre güncelleyebilirsiniz
  var SELECTORS = {
    noteTrigger: '.cartTool-item.cart-tool-note[data-popup]', // "Garanti Bilgisi"
    checkout: '#cart-sidebar-checkout, .previewCartGroup .button-checkout',
    viewCart: '.previewCartGroup .button-view-cart'
  };

  var verified = false; // isim yazılana kadar false

  function disableUI() {
    document.querySelectorAll(SELECTORS.checkout).forEach(function (el) {
      el.disabled = true;
      el.classList.add('is-disabled');
      el.setAttribute('aria-disabled', 'true');
    });
    document.querySelectorAll(SELECTORS.viewCart).forEach(function (el) {
      el.classList.add('is-disabled');
      el.setAttribute('aria-disabled', 'true');
      el.setAttribute('tabindex', '-1');
    });
  }

  function enableUI() {
    document.querySelectorAll(SELECTORS.checkout).forEach(function (el) {
      el.disabled = false;
      el.classList.remove('is-disabled');
      el.removeAttribute('aria-disabled');
    });
    document.querySelectorAll(SELECTORS.viewCart).forEach(function (el) {
      el.classList.remove('is-disabled');
      el.removeAttribute('aria-disabled');
      el.removeAttribute('tabindex');
    });
  }

  function enforce() {
    verified ? enableUI() : disableUI();
  }

  // 1) Buton tıklamalarını globalde yakala (elemanlar sonradan gelse bile)
  document.addEventListener(
    'click',
    function (e) {
      var target = e.target.closest(SELECTORS.checkout + ',' + SELECTORS.viewCart);
      if (target && !verified) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (!document.body.dataset.gbWarn) {
          alert("Devam etmek için önce 'Garanti Bilgisi' alanına isim yazın.");
          document.body.dataset.gbWarn = '1';
        }
      }
    },
    true // capture phase
  );

  // Her ihtimale karşı submit’leri de engelle
  document.addEventListener(
    'submit',
    function (e) {
      if (!verified) e.preventDefault();
    },
    true
  );

  // 2) Garanti Bilgisi popup’ındaki input’u izle
  function wirePopupWatcher() {
    var trigger = document.querySelector(SELECTORS.noteTrigger);
    if (!trigger) return;

    trigger.addEventListener('click', function () {
      // Popup DOM’a eklensin diye ufak bir gecikme
      setTimeout(function () {
        var popupId = trigger.getAttribute('data-popup'); // örn: "popup-tool-note"
        var popup =
          document.getElementById(popupId) ||
          document.querySelector('#' + popupId + ', .' + popupId);

        if (!popup) return;

        var field = popup.querySelector('input[type="text"], textarea');
        if (!field) return;

        function check() {
          verified = field.value.trim().length > 0;
          enforce();
        }
        field.addEventListener('input', check);
        check(); // mevcut değer için ilk kontrol
      }, 150);
    });
  }

  // 3) Mini sepet içerikleri dinamik olduğundan sürekli izle
  var mo = new MutationObserver(function () {
    enforce();
    wirePopupWatcher();
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // İlk çalıştırma
  enforce();
  wirePopupWatcher();

  // (İsteğe bağlı) basit disabled görünümü için küçük bir stil enjekte ediyoruz
  if (!document.getElementById('gb-disabled-style')) {
    var style = document.createElement('style');
    style.id = 'gb-disabled-style';
    style.textContent =
      '.is-disabled{opacity:.5;pointer-events:none;cursor:not-allowed;}';
    document.head.appendChild(style);
  }
})();

/* Garanti alanına isim yazdırma zorunlu */